import React from 'react'
import { useFormikContext } from 'formik'
import { styled, s } from '@vega/styled'
import { Prompt as OriginalPrompt } from 'features/broker/applications/components/typography'
import { Properties } from './Properties'
import { TextField, RadioButtonField, RadioButton } from '@vega/components'
import { TEST_IDS } from '@vega/constants'

const Prompt = styled(OriginalPrompt)(s('mt-6'))

function AssetsAndProperties({ parentPath, applicantPathId }) {
  const { values } = useFormikContext()

  const applicantHasShares =
    values?.financials?.[applicantPathId]?.assets?.shares?.eligibility

  const applicantHasProperties =
    values?.financials?.[applicantPathId]?.assets?.property?.eligibility

  return (
    <div>
      <Prompt>
        First, Cash in saving. How much cash have do you have saved for your deposit?
        This information to determine on how much you can borrow
      </Prompt>
      <TextField
        name={`${parentPath}.assets.cashSavings.amount`}
        aria-label="Cash"
        prefix="$"
        containerStyle={s('w-1/2')}
        testId={TEST_IDS.CASH_SAVINGS_INPUT}
      />

      <Prompt style={s('mb-4')}>Do you own any shares (stocks)?</Prompt>
      <RadioButtonField
        name={`${parentPath}.assets.shares.eligibility`}
        aria-label="Shares value Eligibility"
        containerStyle={s('mb-4')}
        testId={TEST_IDS.HAS_STOCKS_RB}
      >
        <RadioButton value={true}>Yes</RadioButton>
        <RadioButton value={false}>No</RadioButton>
      </RadioButtonField>

      {applicantHasShares && (
        <>
          <Prompt>Please enter amount of their current value?</Prompt>
          <TextField
            name={`${parentPath}.assets.shares.amount`}
            aria-label="Shares value"
            prefix="$"
            containerStyle={s('w-1/2 mb-4')}
            testId={TEST_IDS.STOCKS_AMOUNT_INPUT}
          />
        </>
      )}

      <Prompt style={s('mt-0 mb-4')}>Do you own any property?</Prompt>
      <RadioButtonField
        name={`${parentPath}.assets.property.eligibility`}
        aria-label="Is owned any properties"
        containerStyle={s('mb-4')}
        testId={TEST_IDS.HAS_PROPERTY_RB}
      >
        <RadioButton value={true}>Yes</RadioButton>
        <RadioButton value={false}>No</RadioButton>
      </RadioButtonField>

      {applicantHasProperties && (
        <Properties parentPath={parentPath} applicantPathId={applicantPathId} />
      )}
    </div>
  )
}

export { AssetsAndProperties }
